import {Injectable} from '@angular/core';
import { FrontSessionStorageService } from '../storage/sessionStorage.service';
import { StationDto } from '../../domain/infra/station/station';
import {PaynowStationContext} from '../../domain/paynowStationContext';
import {Observable, map} from 'rxjs';

export const PAYNOW_STATION_CONTEXT = 'paynowStationContext';

@Injectable({
    providedIn: 'root'
})
export class PaynowStationContextService {
    constructor(private readonly storageService: FrontSessionStorageService) {}

    public set(paynowStationContext: PaynowStationContext): void {
        this.storageService.set(PAYNOW_STATION_CONTEXT, paynowStationContext).subscribe();
    }

    public get(contextId: string): Observable<PaynowStationContext | undefined> {
        return this.storageService.get<PaynowStationContext>(PAYNOW_STATION_CONTEXT)
            .pipe(
                map(paynowStationContext => {
                    if (paynowStationContext && paynowStationContext.contextId !== contextId) {
                        return undefined;
                    }

                    return paynowStationContext;
                })
            );
    }

    public getStation(contextId: string): Observable<StationDto | undefined> {
        return this.get(contextId)
            .pipe(
                map(paynowStationContext => paynowStationContext?.station)
            );
    }

    public remove(): void {
        this.storageService.remove(PAYNOW_STATION_CONTEXT);
    }
}
